import React from "react";
import { BadgeCheck, HeartHandshake, Wallet, ShieldCheck } from "lucide-react";
import { WHY_US, STATS } from "../mock/mock";

const iconMap = { BadgeCheck, HeartHandshake, Wallet, ShieldCheck };

const WhyChoose = () => {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative">
          <div className="relative rounded-3xl overflow-hidden aspect-[4/5] shadow-2xl">
            <img
              src="https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=900&q=80"
              alt="Taj Mahal"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -right-6 hidden md:block bg-white rounded-2xl shadow-2xl p-6 max-w-xs">
            <div className="flex -space-x-3">
              {[45, 32, 52, 68].map((n) => (
                <img
                  key={n}
                  src={`https://i.pravatar.cc/60?img=${n}`}
                  className="w-10 h-10 rounded-full border-2 border-white"
                  alt="traveller"
                />
              ))}
            </div>
            <div className="mt-3 text-sm font-semibold text-slate-900">15,000+ Happy Travellers</div>
            <div className="text-xs text-slate-500">rate us 4.9/5 on Google</div>
          </div>
          <div className="absolute -top-6 -left-6 hidden md:block bg-teal-600 text-white rounded-2xl shadow-2xl p-5">
            <div className="text-3xl font-bold" style={{ fontFamily: "'Poppins', sans-serif" }}>2025</div>
            <div className="text-xs uppercase tracking-wider">Est. Year</div>
          </div>
        </div>

        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-100 text-orange-700 text-xs font-semibold tracking-wider uppercase">
            <span className="w-1.5 h-1.5 rounded-full bg-orange-500" /> Why Choose Us
          </div>
          <h2 className="mt-4 text-3xl md:text-5xl font-bold text-slate-900 tracking-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>
            We treat every trip like our own
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            Since 2025, PMR Travels has served families, corporates and pilgrims across India with one uncompromising promise — safety, comfort and value.
          </p>

          <div className="mt-8 grid sm:grid-cols-2 gap-5">
            {WHY_US.map((w) => {
              const Icon = iconMap[w.icon];
              return (
                <div
                  key={w.title}
                  className="group p-5 rounded-xl border border-slate-200 hover:border-teal-400 hover:bg-teal-50/40 transition"
                >
                  <div className="w-11 h-11 rounded-lg bg-teal-600 text-white flex items-center justify-center group-hover:bg-orange-500 transition">
                    <Icon className="w-5 h-5" />
                  </div>
                  <h3 className="mt-3 font-bold text-slate-900">{w.title}</h3>
                  <p className="mt-1 text-sm text-slate-600 leading-relaxed">{w.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="mt-20 max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 rounded-2xl overflow-hidden bg-gradient-to-r from-teal-700 to-teal-600 text-white">
          {STATS.map((s, i) => (
            <div
              key={s.label}
              className={`p-8 text-center ${i < 3 ? "md:border-r border-white/15" : ""} ${i < 2 ? "border-b md:border-b-0 border-white/15" : ""}`}
            >
              <div className="text-4xl md:text-5xl font-bold" style={{ fontFamily: "'Poppins', sans-serif" }}>
                {s.value}
              </div>
              <div className="mt-1 text-sm text-white/80 uppercase tracking-wider">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
